export const TRANSACTION_TYPE = {
  VOUCHER_TIP_WITHDRAWAL: 'VOUCHER_TIP_WITHDRAWAL',
  WITHDRAWAL: 'WITHDRAWAL',
  DEPOSIT: 'DEPOSIT',
  CASH_REGISTER_CORRECTION_WITHDRAWAL: 'CASH_REGISTER_CORRECTION_WITHDRAWAL',
  CASH_REGISTER_CORRECTION_DEPOSIT: 'CASH_REGISTER_CORRECTION_DEPOSIT',
  CARD_TIP_WITHDRAWAL: 'CARD_TIP_WITHDRAWAL',
  REFUNDED_CARD_TIP_DEPOSIT: 'REFUNDED_CARD_TIP_DEPOSIT',
  REFUNDED_VOUCHER_TIP_DEPOSIT: 'REFUNDED_VOUCHER_TIP_DEPOSIT',
};

export const TYPE = {
  CANCELLATION: 'CANCELLATION',
  CHECKOUT: 'CHECKOUT',
  VENUE_TRANSACTION: 'VENUE_TRANSACTION',
  QUOTE: 'QUOTE',
  VOID: 'VOID',
  TIP: 'TIP',
};

export const DISPLAY_TYPE = {
  SALE: 'SALE',
  REFUND: 'REFUND',
  TIP: 'TIP',
  WITHDRAWAL: 'WITHDRAWAL',
  DEPOSIT: 'DEPOSIT',
};

export const PAYMENT_TYPE = {
  CASH: 'CASH',
  PREPAID: 'PREPAID',
  DEPOSIT: 'DEPOSIT',
  CARD: 'CARD',
  VOUCHER: 'VOUCHER',
  TAP_TO_PAY: 'TAP_TO_PAY',
  TERMINAL: 'TERMINAL',
};

export interface TransactionLineItem {
  name?: string;
  amount: number;
  taxRate: number;
  taxAmount: number;
  type?: string;
}

export interface TransactionPayment {
  type: string;
  amount: number;
  description?: string;
  notes?: string;
  voucherIssuer?: string;
  voucherCode?: string;
}
